import API from "../utilities/LocalApiProxy";

export function getMandatoryProfilingSettings() {
	return API.get("/settings/mandatoryProfilingSettings").then((response) => {
		return response.mysql;
	});
}

export function updateMandatoryProfilingSetting(settings) {
	// settings format: {
	//   mandatoryProfilingEnabled: boolean,
	//   requiredFields: {
	//     documentType: boolean,
	//     documentStatus: boolean,
	//     documentTags: boolean
	//   },
	//   excludedExtensions: []
	// }
	return API.post("/settings/mandatoryProfilingSettings", {
		body: settings,
	}).then(() => {
		return settings;
	});
}
